export default __webpack_public_path__ + "static/media/whatCard2.e65d93d8.webp";